import gql from 'graphql-tag';

export default gql`
  mutation removeByIdUserGroupMutation($_id: MongoID!) {
    removeByIdUserGroupMutation(_id: $_id) {
      record {
        _id
      }
    }
  }
`;
